import React from 'react'
import Link from 'gatsby-link'

import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="philosophy" className={`${this.props.article === 'philosophy' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Philosophy</h2>
          <span className="image main"><img src={pic01} alt="" /></span>
          <h1><a id="Teaching_Philosophy_0"></a>Teaching Philosophy</h1>
          <p>I am a champion for the voice of an individual. In my classroom, I maintain a spirit of freedom in an environment that is inviting and welcoming to learners of dance of all ages, from all backgrounds, with all levels of life and dance experience, all with uniquely designed futures ahead.</p>
          <p>I strive to maintain a dance room that is free of judgement. My learners are welcome to come as they are, and leave whatever they wish behind. My goal is to inspire creativity, individual thinking, and a mindset to never stop discovering and growing.</p>
          <p>Some people are born to inspire others with movement in front of crowds of thousands. Some people are born to inspire classrooms of twenty. Some people are lucky enough to have experienced both. I will strive to allow my students to realize their personal goals on and off the stage, in and out of the classroom. Each student will set an intention, either aloud or in a journal, and set an overall goal for the month. We will revisit these goals monthly and evaluate where we need to focus our time, energy, and attention as a team. We will lean on one another, and reach our goals both as a classroom unit and as individuals.</p>
          <p>I value preparedness: I will arrive to class ready to teach my students, ready to learn from my students, and ready to create with my students. Any opportunity to share the floor will be held with the upmost respect. While using a preexisting syllabus and lesson plan, I will remain flexible and present in the moment, and allow the class to proceed at a natural pace. In my opinion, part of making a perfect plan of action is allowing that plan to unfold differently than anticipated.</p>
          <p>I value being present: In my life, my dance teacher was far more than a dance teacher. She was a mentor. She was a mom. She was a friend. She was a doctor. She was an expert. She was a therapist. I am so honored to be able to carry that tradition to my students. I will be there for them, open and ready to learn and share.</p>
          <p>It is my goal to inspire students to become better dancers, better sons and daughters, better friends, better parents,  better cohabitants of the earth, and better people, who continue to grow every single day.</p>
          {close}
        </article>

        <article id="work" className={`${this.props.article === 'work' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Work</h2>
          <span className="image main"><img src={pic02} alt="" /></span>
          <h1><a id="Resume_0"></a>Resume</h1>
          <h2><a id="Performance_Experience_2"></a>Performance Experience</h2>
          <p><strong>Atmosphere Performer/Dancer/Improv Actor</strong></p>
          <table className="table table-striped table-bordered">
            <thead>
            <tr>
              <th><strong>Gaylord Palms Resort</strong></th>
              <th>Princess Fiona</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><strong>Nickelodeon Suites Resorts</strong></td>
              <td>Team Nick, Celebrate Nickmas, Bikini Bottom Breakfast, Krabby Patty Celebration, Dora’s Friendship
                Fiesta, Ninja Turtle EventsTeam Nick, Celebrate Nickmas, Bikini Bottom Breakfast, Krabby
              </td>
            </tr>
            <tr>
              <td><strong>Nickelodeon Suites Resorts</strong></td>
              <td>Power Ranger Event, Yellow Ranger High Voltage Extreme Street Beats, Universal Studios- Tap Dancer
              </td>
            </tr>
            <tr>
              <td><strong>Sea World’s Halloween Spooktacular</strong></td>
              <td>Odd-O-Ts’ Entertainment- Sea Star</td>
            </tr>
            <tr>
              <td><strong>Sea World’s Christmas Celebration</strong></td>
              <td>Odd-O-Ts’ Entertainment- Polar Express Elf</td>
            </tr>
            <tr>
              <td><strong>Murder Mystery, Inc</strong></td>
              <td>Improv Actor &amp; Tap Dancer</td>
            </tr>
            </tbody>
          </table>
          <p><strong>Character Animation</strong></p>
          <table className="table table-striped table-bordered">
            <thead>
            <tr>
              <th><strong>Gaylord Palms Resort</strong></th>
              <th>Animated Dancer</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><strong>Universal Studios Florida</strong></td>
              <td>Animated Dancer, HOP</td>
            </tr>
            <tr>
              <td><strong>Universal Studios Florida</strong></td>
              <td>Animated Street Star</td>
            </tr>
            <tr>
              <td><strong>Nickelodeon Suites Resorts</strong></td>
              <td>Animated Character/ Dancer</td>
            </tr>
            </tbody>
          </table>
          <p><strong>Puppetry</strong></p>
          <p>| Nickelodeon Suites Resorts | |</p>
          <p><strong>Theatre</strong></p>
          <table className="table table-striped table-bordered">
            <thead>
            <tr>
              <th><strong>TITLE</strong></th>
              <th><strong>ROLE</strong></th>
              <th><strong>COMPANY/DIRECTOR</strong></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><strong><em>Proof</em></strong></td>
              <td>Catherine</td>
              <td>Day &amp; Night Theatre Co.</td>
            </tr>
            <tr>
              <td><strong><em>Barefoot in the Park</em></strong></td>
              <td>Mother</td>
              <td>Day &amp; Night Theatre Co.</td>
            </tr>
            <tr>
              <td><strong><em>Thoroughly Modern Millie</em></strong></td>
              <td>Ms. Flannery, Pearl Lady</td>
              <td>Laura Carroll, Kathy Hudnall</td>
            </tr>
            <tr>
              <td><strong><em>Pirates and Princess</em></strong></td>
              <td>Dancer, Chorus</td>
              <td>Laura Carroll, Kathy Hudnall</td>
            </tr>
            <tr>
              <td><strong><em>Back to the 80’s</em></strong></td>
              <td>Laura, Debbie, Chorus</td>
              <td>Laura Carroll, Kathy Hudnall</td>
            </tr>
            <tr>
              <td><strong><em>An Enchanted Christmas</em></strong></td>
              <td>Cindy Lou Who</td>
              <td>Laura Carroll, Kathy Hudnall</td>
            </tr>
            <tr>
              <td><strong><em>Frazzled Fairy Tales</em></strong></td>
              <td>Little Red Riding Hood</td>
              <td>Laura Carroll, Kathy Hudnall</td>
            </tr>
            <tr>
              <td><strong><em>Grease</em></strong></td>
              <td>Dancer</td>
              <td>Sherry Febles</td>
            </tr>
            <tr>
              <td><strong><em>Damn Yankees</em></strong></td>
              <td>Dancer</td>
              <td>Sherry Febles</td>
            </tr>
            <tr>
              <td><strong><em>The Jungle Book</em></strong></td>
              <td>Monkey/Dari</td>
              <td>Mary Wilson</td>
            </tr>
            </tbody>
          </table>
          <h2><a id="ChoreographyTeaching_41"></a>Choreography/Teaching</h2>
          <p><strong>Williamson County Parks &amp; Recreation: Rhythm &amp; Spirit Program</strong><br />
            Ballet, Tap, Jazz, Tumbling, Cheer, Hip Hop, Mommy &amp; Me Tumbling<br />
            <strong>New Vision Baptist Church’s Praise &amp; Dance Team</strong><br />
            Director and Choreographer<br />
            <strong>Preschool Tumbling independently at various preschools in Rutherford and Williamson
              Counties</strong><br />
            <strong>SADM Certified Teaching Licenses</strong><br />
            Tap, Jazz, Acrobatics<br />
            <strong>Broadway Bound Theater &amp; Dance Camps</strong> Choreographer Columbia State Community College</p>
          <table className="table table-striped table-bordered">
            <thead>
            <tr>
              <th><strong>SCMS Dance Team</strong></th>
              <th>Choreographer</th>
              <th>Stewarts Creek Middle School</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><strong>Aladdin Junior</strong></td>
              <td>Choreographer</td>
              <td>Stewarts Creek Middle School</td>
            </tr>
            <tr>
              <td><strong>The Music Man</strong></td>
              <td>Choreographer</td>
              <td>Stewarts Creek Middle School</td>
            </tr>
            </tbody>
          </table>
          <h2><a id="Training_57"></a>Training</h2>
          <table className="table table-striped table-bordered">
            <thead>
            <tr>
              <th><strong><em>Jazz</em></strong></th>
              <th>Southern Association of Dance Masters-20yrs</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><strong><em>Ballet</em></strong></td>
              <td>MTSU Meg Brooker, Jen Macnamara ******</td>
            </tr>
            <tr>
              <td>Southern Association of Dance Masters-20yrs</td>
              <td></td>
            </tr>
            <tr>
              <td><strong><em>Modern</em></strong></td>
              <td>MTSU Marsha Barsky</td>
            </tr>
            <tr>
              <td><strong><em>Tap</em></strong></td>
              <td>Southern Association of Dance Masters-20yrs</td>
            </tr>
            <tr>
              <td><strong><em>Lyrical</em></strong></td>
              <td>Southern Association of Dance Masters-17yrs ******</td>
            </tr>
            <tr>
              <td><strong><em>Vocal</em></strong></td>
              <td>Cathy Hudnell (CSCC) 4yrs</td>
            </tr>
            <tr>
              <td><strong><em>Acting/Theatre</em></strong></td>
              <td>Crosby Hunt (MTSU) 4ys Paul Clapper (CSCC) 4yrs</td>
            </tr>
            <tr>
              <td><strong><em>Hip Hop</em></strong></td>
              <td>Southern Association of Dance Masters- 10yrs</td>
            </tr>
            </tbody>
          </table>
          <h2><a id="Special_Skills_69"></a>Special Skills</h2>
          <p>Acrobatics (Back Walkover, Split Rolls, Head Stand, Hand Stand, Front Handsprings/ Flip flop, Round-off,
            Cartwheels etc.), Puppetry, Roller Skating/ Blading, Stagecraft Courses at MTSU and CSCC, Wardrobe and
            Costuming at MTSU and CSCC, Basic Stilts, Silk Hammock Training, Yoga Training</p>
          {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <span className="image main"><img src={pic03} alt="" /></span>
          <p>Upon graduating college in 2009 with an Associates Degree in Commercial Entertainment, and a Certificate in Dance, Brittney moved to Orlando, Florida to pursue a career in Dance and Entertainment. There she worked for Walt Disney World, Nickelodeon Suites Resorts, Sea World, Universal Studios, and Gaylord Palms Entertainment, specializing in character work, puppetry, and atmosphere improvisation acting. Ready to fulfill a lifelong dream of dance instruction, Brittney moved back home to Murfreesboro, Tennessee and began working for the Williamson County Parks and Recreation’s Rhythm and Spirit Program. She currently teaches Ballet, Tap, Jazz, Cheer, Tumble, and Hip Hop classes. Recently, she graduated from Middle Tennessee State University with her Bachelors Degree in Dance. Dancing is her passion, children are her heart.</p>
          {close}
        </article>

        <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Contact</h2>
          <form method="post" action="#">
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4"></textarea>
            </div>
            <ul className="actions">
              <li><input type="submit" value="Send Message" className="special" /></li>
              <li><input type="reset" value="Reset" /></li>
            </ul>
          </form>
          <ul className="icons">
            <li><a href="https://www.twitter.com/brittney_dance" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="https://www.instagram.com/ilvlcy" className="icon fa-instagram"><span className="label">Instagram</span></a></li>
            <li><a href="https://www.facebook.com/brittney.laura.brewer" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
            <li><a href="https://www.linkedin.com/in/brittney-brewer" className="icon fa-linkedin"><span className="label">LinkedIn</span></a></li>
          </ul>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js